export default __webpack_public_path__ + "static/media/hybrid.934da67c.jpg";